<section id="basic-dropdown" style="margin-top: 8px">
    <div class="row">
        <div class="col-12">
            <div>
                <div class="btn-group">
                    <div ngbDropdown>
                        <button
                                type="button"
                                class="btn btn-primary dropdown-toggle"
                                id="addMenu"
                                ngbDropdownToggle
                                aria-expanded="false">
                            Ajouter
                        </button>
                        <div ngbDropdownMenu aria-labelledby="addMenu">
                            <ng-container *ngFor="let option of options">
                                <a ngbDropdownItem (click)="selectOption(option)">
                                    {{ option }}
                                </a>
                            </ng-container>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>


